export default "recent-legendary-levels = 最近新增的传奇关卡\nlink-quality-guideline = Hidden/Unlisted 가이드라인\n"